import {INITIAL_LAYOUT} from '../constants'
import type {KilnConfigState} from '../types'

export const getEmptyKilnConfig = (): KilnConfigState => {
  return {
    layout: INITIAL_LAYOUT,
    configuration: {
      name: '',
      dimensions: {
        length: 0,
        diameter: 0
      },
      isRotationClockwise: false,
      feedSignals: [],
      speedSignals: [],
      ovalitySignals: [],
      crankSignals: [],
      axialMovementSignals: [],
      heatZones: [],
      cones: []
    },
    signalMappings: []
  }
}
